<template>
  <el-autocomplete
    style="width:100%"
    :value="value"
    :fetch-suggestions="handleCountrys"
    :placeholder="placeholder"
    :trigger-on-focus="false"
    @input="updateSelf"
  />
</template>

<script>
import { getCountryList } from '@/api/country'
export default {
  name: 'CountrySelector',
  model: {
    prop: 'value',
    event: 'input'
  },
  props: ['value', 'placeholder'],
  data() {
    return {
      countryObj: {}
    }
  },
  methods: {
    updateSelf(e) {
      this.$emit('input', e)
    },
    handleCountrys(countryCode, callback) {
      const params = {
        item: countryCode
      }
      getCountryList(params).then(res => {
        if (!res.ok) {
          callback([])
        } else {
          const obj = {}
          res.data.map(item => {
            obj[item.chineseName] = item.code
            return item
          })
          this.countryObj = obj

          this.options = res.data.map(item => {
            return {
              value: item.chineseName
            }
          })
          callback(this.options)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
